/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from '../../../../styles/general.module.scss';

const UserApplications = (props) => {
  const { data, renewBadge, rejectBadge } = props;

  const getStatus = (ele) => {
    if (ele === 0) {
      return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>In Progress</div>;
    } if (ele === 1) {
      return <div style={{ background: '#6DD4001C', color: '#6DD400' }} className={styles.badge}>Approved</div>;
    } if (ele === 2) {
      return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>Rejected</div>;
    } if (ele === 4) {
      return <div style={{ background: '#F5515F22', color: '#F5515F' }} className={styles.badge}>Signatory Review</div>;
    } if (ele === 5) {
      return <div style={{ background: '#d0d0d0', color: '#454545' }} className={styles.badge}>Airport Staff Review</div>;
    } if (ele === 6) {
      return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>Initiated</div>;
    } if (ele === 7) {
      return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>Expired</div>;
    } return null;
  };
  return (
    <div style={{ width: '100%' }}>
        <>
          <h3 style={{ color: 'white', marginLeft: '13%', marginTop: '3%' }}>Applications</h3>
          <table className={styles.table} style={{ margin: 'auto', marginBottom: '3%', width: '75%' }}>
            <thead>
              <tr style={{ background: 'rgb(233,239,244)', whiteSpace: 'pre' }}>
                <th style={{ color: 'rgba(50, 51, 102, 1)' }}>
                  <FormattedMessage id="module.id" defaultMessage="Full Name" />
                </th>
                <th style={{ color: 'rgba(50, 51, 102, 1)' }}>
                  <FormattedMessage id="module.id" defaultMessage="Status" />
                </th>
                <th style={{ color: 'rgba(50, 51, 102, 1)' }}>
                  <FormattedMessage id="module.id" defaultMessage="Action" />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ color: 'rgba(50, 51, 102, 1)' }}>{`${data.first_name} ${data.last_name}`}</td>
                <td style={{ color: 'rgba(50, 51, 102, 1)' }}>{getStatus(data?.status)}</td>
                {data.status === 7 && (
                <div onClick={() => renewBadge(data.id)}>
                  <td style={{ color: 'rgba(50, 51, 102, 1)', paddingTop: '20px', cursor: 'pointer' }}>Renew</td>
                </div>
                )}
                {data.status === 2 && (
                <div onClick={() => rejectBadge(data.id)}>
                  <td style={{ color: 'rgba(50, 51, 102, 1)', paddingTop: '20px', cursor: 'pointer' }}>Reopen</td>
                </div>
                )}
              </tr>
            </tbody>
          </table>
        </>
    </div>
  );
};
export default UserApplications;
